import React, { useContext } from 'react'
import { useForm } from 'react-hook-form'
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup";

import Button from '@/components/Button'
import { AuthContext } from '../contexts/AuthContext';
import { ModalContext } from '@/contexts/ModalContext'

export default function SetUsername() {
  const { user, setUsername } = useContext(AuthContext);
  const { closeModal } = useContext(ModalContext)
  const schema = yup.object().shape({
    username: yup.string().required().max(16),
  });

  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      username: ''
    }
  });

  const onSubmitHandler = async (data) => {
    try {
      const username = await setUsername(data.username);
      if (username) closeModal();
    } catch (err) {
      console.log(err.message)
      // alert(err.message)
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmitHandler)} className="grid gap-4">
      <p className="text-center text-white font-medium text-lg">Welcome, {user?.username}</p>
      <p className="text-gray-300">You must set a username before accessing our application. You're most likely seeing this message because you have:</p>
      <ul className="list-inside list-disc">
        <li>Recently registered your account using Social Registration</li>
        <li>Had an offensive previous username removed by a moderator</li>
      </ul>
      <div className="grid grid-cols-3 gap-2">
        <div className="col-span-2">
          <input {...register('username')} type="text" className={errors?.username ? '!border-red-500' : ''} />
        </div>
        <Button type="submit" className="py-2.5">
          {isSubmitting ? (
            <span className="flex items-center justify-center">
              Processing
              <svg className="animate-spin ml-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </span>
          ) : (
            <span>Save</span>
          )}
        </Button>
      </div>
    </form>
  )
}
